/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 */
import React from "react";
import {IconDeliveryTruck} from "../../../../../../../components/buttons/IconButtons";
import GateLogGroup from "./GateLogGroup";
import GateLogValueBox from "./GateLogValueBox";
import {hasGateLogValue} from "../../../../Model/Model";
import {VEHICLE_ROWS} from "../../CratesAndPalletsReturn/Model/Model";

/**
 * Transport that carries the materials: the value that names who moves them
 * takes the whole row and the rest of the values of the vehicle are paired in
 * halves, each one with the user that registered it.
 *
 * The movements that do not travel with a carrier declare their own row and
 * their own values, so the same group is read by every form.
 *
 * Every value of the vehicle is optional for the requester, so the one that was
 * left blank is read as waiting for whoever writes it, the same way the rest of
 * the log reads what the gate has not registered yet. A movement the gate
 * already closed is no longer waited for, so the log that reads it declares the
 * text its blank values are read with.
 */
const TransportSection = ({
                              t,
                              transport,
                              carrierAction = null,
                              vehicleAction = null,
                              carrierTrans = 'carrier_company',
                              carrierField = 'carrierCompany',
                              rows = VEHICLE_ROWS,
                              emptyText = null
                          }) => {
    const blankValue = emptyText ?? t("pending");

    // Every value says who wrote it and when, so the chip is built for the
    // field it belongs to, with the value it carries, instead of being the same
    // one for the whole vehicle.
    //
    // A field nobody has written yet has nobody to name, so the chip of a value
    // that is still blank is not read.
    const actionOf = (action, field) => {
        if (typeof action === 'function')
            return action(field, transport?.[field]);

        return hasGateLogValue(transport?.[field]) ? action : null;
    };

    return (
        <GateLogGroup Icon={IconDeliveryTruck} title={t("transport")}>
            <div className={"row"}>
                <div className={"col-12 px-1"}>
                    <GateLogValueBox
                        label={t(carrierTrans)}
                        value={transport?.[carrierField] || blankValue}
                        action={actionOf(carrierAction, carrierField)}
                        className={"mb-3"}
                    />
                </div>

                {rows.map(row =>
                    <div key={row.field} className={"col-sm-12 col-md-6 px-1"}>
                        <GateLogValueBox
                            label={t(row.trans)}
                            value={transport?.[row.field] || blankValue}
                            action={row.registered ? actionOf(vehicleAction, row.field) : null}
                            className={"mb-3"}
                        />
                    </div>
                )}
            </div>
        </GateLogGroup>
    );
};

export default TransportSection;
